import { useMemo } from 'react';

const FIELDS_NAMES = {
  FULL_CONTENT_MAGIC_WORDS: 'Full Content Magic Words',
  BREAK_MAGIC_WORDS: 'Break Magic Words',
};

const DEFAULT_SUPPLY_SOURCE_POD_DETAILS = [{ label: FIELDS_NAMES.BREAK_MAGIC_WORDS, value: '-' }];

const DEFAULT_SUPPLY_SOURCE_FULL_CONTENT_MAGIC_WORDS = [{ label: FIELDS_NAMES.FULL_CONTENT_MAGIC_WORDS, value: '-' }];

const podDetailsResolver = (data) => {
  const getBreakSubjectTags = (tags = []) => {
    if (tags === null) {
      return [];
    }

    return tags.reduce((acc, tag) => [...acc, tag?.value] || acc, []);
  };

  return {
    label: FIELDS_NAMES.BREAK_MAGIC_WORDS,
    value: [
      ...new Set(
        data?.rawData?.['pod-info']?.reduce((acc, pod) => {
          // TODO: once new API for break-subject-tags will be implemented
          // we will no need to support subject-tags here
          const breakSubjectTags = getBreakSubjectTags(pod?.['break-subject-tags']);
          const isTagsValid = Array.isArray(pod?.['subject-tags']);
          return isTagsValid ? [...acc, ...pod?.['subject-tags'], ...breakSubjectTags] : acc;
        }, [])
      ),
    ],
  };
};

const fullContentMagicWordsResolver = (data) => {
  return {
    label: FIELDS_NAMES.FULL_CONTENT_MAGIC_WORDS,
    value: [
      ...new Set(
        data?.rawData?.content?.['full-subject-tags']?.reduce((acc, item) => {
          return [...acc, item?.value] || acc;
        }, [])
      ),
    ],
  };
};

export const resolveSupplySourcePodDetailsResolver = (data) => {
  return data ? podDetailsResolver(data) : DEFAULT_SUPPLY_SOURCE_POD_DETAILS;
};

export const resolveSupplySourceFullContentMagicWords = (data) => {
  return data ? fullContentMagicWordsResolver(data) : DEFAULT_SUPPLY_SOURCE_FULL_CONTENT_MAGIC_WORDS;
};

export const useSupplySourcePodDetailsResolverResolver = (data) => {
  return useMemo(() => resolveSupplySourcePodDetailsResolver(data), [data]);
};
